import AES from 'crypto-js/aes';
import SHA256 from 'crypto-js/sha256';
import Hex from 'crypto-js/enc-hex';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import WordArray from 'crypto-js/lib-typedarrays';

export const encrypt = (data, key) => {
  const iv = WordArray.create(crypto.getRandomValues(new Uint8Array(16)));
  const keyHash = SHA256(key);
  const b64 = AES.encrypt(data, keyHash, {
    iv
  }).toString();
  const encrypted = Base64.parse(b64).toString(Hex);
  return `${iv}.${encrypted}`;
};

export const decrypt = (data, key) => {
  try {
    const keyHash = SHA256(key);
    const [siv, encrypted] = data.split('.');
    const iv = Hex.parse(siv);
    const bytes = Hex.parse(encrypted).toString(Base64);
    const decrypted = AES.decrypt(bytes, keyHash, {
      iv
    });
    if (decrypted === null) {
      throw new Error();
    } else {
      return decrypted.toString(Utf8);
    }
  } catch (e) {
    throw new Error();
  }
};
